module.exports = function getResource(label, vars = []) {
    let resources = {
        add: 'Ajouter',
        remove: 'Supprimer',
        addedText: 'Ajouté'
    };

    return resources[label];
};
